import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=3708340c&scoped=true&"
import script from "./Save.vue?vue&type=script&lang=js&"
export * from "./Save.vue?vue&type=script&lang=js&"
import style0 from "./Save.vue?vue&type=style&index=0&id=3708340c&prod&scoped=true&lang=scss&"
import style1 from "./Save.vue?vue&type=style&index=1&id=3708340c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708340c",
  null
  
)

export default component.exports